module.exports = __webpack_public_path__ + "static/media/img_cake.de74e4e1.png";